import {
  BasePaginateParamsSchema,
  BasePaginateResultSchema,
} from '@/api/common'
import { z } from 'zod'

export const Inv4010SearchParamsSchema = z
  .object({
    itemId: z.coerce.string().optional(), // this value was used in `Select` component, so it should be string
    type: z.string().optional(),
    lotNo: z.string().optional(),
    mold: z.string().optional(),
  })
  .merge(BasePaginateParamsSchema)

export type Inv4010SearchParams = z.infer<typeof Inv4010SearchParamsSchema>

//==============================================================

export const Inv4010SearchResultItemSchema = z.object({
  id: z.number(),
  itemId: z.number(),
  itemCode: z.string(),
  itemName: z.string(),
  lotNo: z.string(),
  mold: z.string(),
  lotDate: z.coerce.date(),
  isClaimItem: z.boolean(),
  availableQty: z.number(),
  reservedQty: z.number(),
  productionQty: z.number(),
  rejectedQty: z.number(),
  qmsQty: z.number(),
  claimQty: z.number(),
})
export type Inv4010SearchResultItem = z.infer<
  typeof Inv4010SearchResultItemSchema
>

//==============================================================

export const Inv4010SearchResultSchema = z
  .object({
    data: z.array(Inv4010SearchResultItemSchema),
  })
  .merge(BasePaginateResultSchema)
export type Inv4010SearchResult = z.infer<typeof Inv4010SearchResultSchema>

//==============================================================
// for fetching locations
export const Inv4010LocationListItemSchema = z.object({
  location: z.string(),
  status: z.string(),
  qty: z.number(),
})
export type Inv4010LocationListItem = z.infer<
  typeof Inv4010LocationListItemSchema
>

export const Inv4010LocationListSchema = z.object({
  id: z.number(),
  locations: z.array(Inv4010LocationListItemSchema),
})
export type Inv4010LocationList = z.infer<typeof Inv4010LocationListSchema>

//==============================================================
